module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"539\" height=\"528.103\" viewBox=\"0 0 539 528.103\">\n   <title>circle_background</title>\n   <desc>Created with Sketch.</desc>\n   <defs>\n   <style>.a{fill:#f7f7f7;}</style>\n   </defs>\n   <path class=\"a\" d=\"M269.5,0C419.369-55.634,539,122,539,272.5S424.26,472.482,269.5,510.737,0,423,0,272.5,119.631,55.634,269.5,0Z\" transform=\"translate(0 10.444)\"/>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/circle-background.svg
// module id = 396
// module chunks = 0